










import Vue from "vue";
import Component from "vue-class-component";

@Component
export default class DadosComplementoComplemento extends Vue {
    get complementocomplemento () {
        return this.$store.state.cotacao.complementocomplemento;
    }

    set complementocomplemento ( value ) {
        this.$store.commit("SET_COMPLEMENTOOCOMPONENTE", value);
    }

    get errorComplementoComplemento () {
        return this.$store.state.errors.complementocomplemento;
    }

    public onChange () {
        this.$store.dispatch("VALIDAR_DADOS")
            .then()
            .catch(() => { return; });
    }
}
